import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from './AdminContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { Lock, Mail, Eye, EyeOff } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === 'accounting' ? '/admin/reports' : '/admin');
    } catch (err) {
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #1B2A6B 0%, #0F1D4A 100%)' }} data-testid="admin-login-page">
      <Card className="w-full max-w-md border-0 shadow-2xl" style={{ background: '#fff' }}>
        <CardContent className="p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 rounded-xl mx-auto mb-4 flex items-center justify-center" style={{ background: '#1B2A6B' }}>
              <Lock className="w-8 h-8" style={{ color: '#B8962E' }} />
            </div>
            <h1 className="text-2xl font-bold" style={{ color: '#1B2A6B', fontFamily: 'Chivo, sans-serif' }}>Admin Portal</h1>
            <p className="text-sm text-gray-500 mt-1">2TI Corp Back Office</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-3 text-center" data-testid="login-error">{error}</div>}
            <div className="space-y-2">
              <Label className="text-sm font-semibold" style={{ color: '#1B2A6B' }}>Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <Input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="admin@2ticorp.com" className="pl-10" required data-testid="login-email" />
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-sm font-semibold" style={{ color: '#1B2A6B' }}>Password</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <Input value={password} onChange={e => setPassword(e.target.value)} type={showPw ? 'text' : 'password'} placeholder="Enter password" className="pl-10 pr-10" required data-testid="login-password" />
                <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full font-semibold text-base h-11" style={{ background: '#B8962E', color: '#fff' }} data-testid="login-submit">
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
